import {throwError as observableThrowError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {environment} from "../../environments/environment";
import {KeycloakService} from "./keycloak.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ConfirmDialogComponent, ConfirmDialogModel} from "./confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {ApiEndpoints} from "./ApiEndpoints";
import {TranslateService} from "@ngx-translate/core";
import {LoaderService} from "./loading-bar/loader.service";

@Injectable()
export class DataService {
  private keyLang = 'measure-lang';
  private accessToken;
  public lang = 'hu';

  protected tokenParam = '';
  protected serverUrl = '';

  authCompleted = false;

  notransParam = "?notrans=1";

  private httpOptions;
  protected http: HttpClient;
  private apiURL = environment.apiURL;
  router: Router;
  notiService: MatSnackBar;
  dialog: MatDialog;
  constructor(
    private injector: Injector,
    private kcService: KeycloakService,
    private _snackBar: MatSnackBar,
    private translate: TranslateService,
    private loaderService: LoaderService,
  ) {
    this.http = injector.get(HttpClient);
    this.router = injector.get(Router);
    this.notiService = injector.get(MatSnackBar);
    this.dialog = injector.get(MatDialog);

    const lang = localStorage.getItem(this.keyLang);
    this.setLocale(lang);

    this.init();
  }

  public setLocale(locale) {
    this.lang = locale ? locale : 'en';
    localStorage.setItem(this.keyLang, this.lang);
    this.translate.use(this.lang);
  }

  public getTranslation(string) {
    return this.translate.instant(string)
  }

  async init() {
    this.accessToken = await this.kcService.getToken();
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.accessToken
      })
    };
  }

  public postRequest(endpoint: string, data: any) {
    return this.handleFinishedRequest(
      this.http
        .post(`${this.apiURL}/${endpoint}`, JSON.stringify(data), this.httpOptions)
    );
  }

  public postFileRequest(endpoint: string, data: FormData) {
    return this.handleFinishedRequest(
      this.http
        .post(`${this.apiURL}/${endpoint}`, data, this.httpOptions)
    );
  }

  public putRequest(endpoint: string, data: any) {
    return this.handleFinishedRequest(
      this.http
        .put(`${this.apiURL}/${endpoint}/${data.id}`, JSON.stringify(data), this.httpOptions)
    );
  }

  public uploadRequest(endpoint: string, data: any) {
    return this.handleFinishedRequest(
      this.http
        .post(`${this.apiURL}/${endpoint}`, data, {
          headers: new HttpHeaders({
            'Authorization': 'Bearer ' + this.accessToken
          })
        })
    );
  }

  public getRequest(endpoint: string, page = 0) {
    return this.handleFinishedRequest(
      this.http.get(`${this.apiURL}/${endpoint}`, this.httpOptions)
    );
  }

  protected deleteRequest(endpoint: string, id) {
    return this.http.delete(`${this.apiURL}/${endpoint}/${id}`);
  }

  public confirmAction(message = 'Do you want to delete this entity?', title = "Confirm") {

    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    return dialogRef.afterClosed();
  }

  protected handleFinishedRequest(observable: any) {
    return observable.pipe(catchError(
          (response: HttpErrorResponse) => {
            this.loaderService.isLoading.next(false);
            let errorMsg = 'Something went wrong!';
            // Unauthorized
            if (response.status === 401) {
              if (response.error && response.error.error && response.error.error === "Not authorized!") {
                this._snackBar.open("Not authorized", "OK", {duration: 5000});
              }
            }
            errorMsg = response.error && response.error.error ? response.error.error : response.error;
            //this.router.navigate(['']);
            return observableThrowError(response.error.message ? response.error.message : errorMsg);
          }
        ));
  }

  getCompanies() {
    return this.getRequest(ApiEndpoints.companies);
  }

  getCompaniesSelectable() {
    return this.getRequest(ApiEndpoints.companies_selectable);
  }

  getSites() {
    return this.getRequest(ApiEndpoints.sites);
  }

  getMeasures() {
    return this.getRequest(ApiEndpoints.measures);
  }

  getUnits() {
    return this.getRequest(ApiEndpoints.units);
  }
}
